<app-modal
  [open]="open"
  (closed)="close(false)"
  class="calendar-add-timeslot-modal"
  >
  <div modal-header>
    <h2>{{'calendar.planning.add-timeslot.title'|transloco: {'day': getDayTranslationKey()} }}</h2>
  </div>

  <div modal-body>
    <app-helper-banner>
      <div helper-content class="calendar-add-timeslot-modal__helper">
        <p>{{'calendar.planning.add-timeslot.explanation'|transloco: {'day': getDayTranslationKey()} }}</p>
      </div>
    </app-helper-banner>
    <form [formGroup]="form" class="calendar-add-timeslot-modal__form" (ngSubmit)="submit()">
      <div class="input-group" [ngClass]="{'invalid': isInvalid('startHour') || isInvalid('startMinute') || isTimeOrderInvalid()}">
        <label>{{'calendar.planning.add-timeslot.start-time.label'|transloco}}</label>
        <div class="time-selectors">
          <select formControlName="startHour">
            <option [value]="null" disabled>--</option>
            @for (h of hours; track h) {
              <option [value]="h">{{ h | number: '2.0' }}</option>
            }
          </select>
          :
          <select formControlName="startMinute">
            <option [value]="null" disabled>--</option>
            @for (m of minutes; track m) {
              <option [value]="m">{{ m | number: '2.0' }}</option>
            }
          </select>
        </div>
        @if (isInvalid('startHour') || isInvalid('startMinute')) {
          <div class="error">
            {{ 'calendar.planning.add-timeslot.start-time.required' | transloco }}
          </div>
        }
      </div>

      <div class="input-group" [ngClass]="{'invalid': isInvalid('endHour') || isInvalid('endMinute') || isTimeOrderInvalid()}">
        <label>{{'calendar.planning.add-timeslot.end-time.label'|transloco}}</label>
        <div class="time-selectors">
          <select formControlName="endHour">
            <option [value]="null" disabled>--</option>
            @for (h of hours; track h) {
              <option [value]="h">{{ h | number: '2.0' }}</option>
            }
          </select>
          :
          <select formControlName="endMinute">
            <option [value]="null" disabled>--</option>
            @for (m of minutes; track m) {
              <option [value]="m">{{ m | number: '2.0' }}</option>
            }
          </select>
        </div>
        @if (isInvalid('endHour') || isInvalid('endMinute')) {
          <div class="error">
            {{ 'calendar.planning.add-timeslot.end-time.required' | transloco }}
          </div>
        }
      </div>

      @if (isTimeOrderInvalid()) {
        <div class="error">
          {{ 'calendar.planning.add-timeslot.time-order' | transloco }}
        </div>
      }
    </form>
  </div>

  <div modal-footer>
    <div class="calendar-add-timeslot-modal__actions">
      <button class="button" [disabled]="form.invalid" (click)="submit()" type="button">
        {{'calendar.planning.add-timeslot.cta'|transloco}}
      </button>
    </div>
  </div>
</app-modal>
